export const MessageRefreshPage = 'Data has been changed. Please refresh the page to see the latest changes';
export const MessageServerError = 'An error occurred. Please try again later or contact Support';
export const MessageError = 'Data has been changed. Please refresh the page to see the latest changes.';
export const MessageSaveSuccessfully = 'Data was updated successfully.';
export const UnsavedDataWarningMessage =
  'You have unsaved changes that will be lost. Are you sure you want to continue?';